import { Helmet } from "react-helmet-async";
import { useLang } from "@/i18n/LanguageContext";

const SITE_URL = "https://atex-5g-edge.com";
const OG_IMAGE = "https://cdn.prod.website-files.com/648a1891f44afca175d3b615/648e3494052fafd80ac65895_edgeOne%20Front_lg.webp";

/**
 * SeoHead writes canonical / hreflang / title / OG tags for the current page.
 * Pass `path` (e.g. "/products/edgeone") for non-home routes so canonical and
 * hreflang entries are emitted correctly.
 */
export default function SeoHead({ path = "/", title, description }) {
  const { lang, t } = useLang();
  const ogLocale = lang === "de" ? "de_DE" : "en_US";
  const altLocale = lang === "de" ? "en_US" : "de_DE";

  // Normalise path: ensure it starts with "/", strip query/hash.
  const cleanPath = (path || "/").split("?")[0].split("#")[0] || "/";
  const pathStr = cleanPath.startsWith("/") ? cleanPath : `/${cleanPath}`;

  // For home we expose the query-string variant for EN canonical, for sub-pages
  // language is communicated only via the document lang attribute.
  const isHome = pathStr === "/";
  const deUrl = `${SITE_URL}${pathStr}`;
  const enUrl = isHome ? `${SITE_URL}/?lang=en` : `${SITE_URL}${pathStr}`;
  const canonical = lang === "de" ? deUrl : enUrl;

  const pageTitle = title || t.meta.title;
  const pageDescription = description || t.meta.description;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="de" href={deUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={deUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ALEGER GLOBAL × RuggedEdge" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:locale:alternate" content={altLocale} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:alt" content="RuggedEdge EdgeOne — ATEX 5G Edge Gateway" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
}
